import React, { useMemo, useReducer } from "react";

import PropTypes from "prop-types";

export const AllocationsPageContext = React.createContext();

const counterReducer = (state, action) => {
    switch (action.type) {
      case 'increment': {
        return {count: state.count + 1}
      }
      case 'decrement': {
        return {count: state.count - 1}
      }
      default: {
        throw new Error(`Unhandled action type: ${action.type}`)
      }
    }
};

export const AllocationsPageContextProvider = (props) => {
    const [rowsInProgress, setRowsInProgress] = useReducer(counterReducer, { count: 0});

    const contextValue = useMemo(() => ({
      rowsInProgress,
      setRowsInProgress,
    }), [rowsInProgress]);

    return (
        <AllocationsPageContext.Provider value={contextValue}>
            {props.children}
        </AllocationsPageContext.Provider>
    );
}

AllocationsPageContextProvider.propTypes = {
    children: PropTypes.node
};

export default AllocationsPageContext;
